import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="bg-navy px-3 py-14 md:px-5 md:py-20" data-id="element-117" data-mp="1clzecp0u5062">
      <div className="mx-auto max-w-6xl" data-id="element-118" data-mp="18juidjmwzrg9">
        <div className="px-2" data-id="element-119" data-mp="18l5o3ozx79a0">
          <SectionHeading dark eyebrow="Plus: 5 Practical Bonuses" title={<>
                5 Bonuses to <span className="text-gold" data-id="element-121" data-mp="20btnowly46lk">Complete Your Workflow</span>
              </>} subtitle="These aren't additional textbooks. They're ready-to-use reference and documentation tools designed to complement the six core volumes." data-id="element-120" data-mp="18hrmiiz2z43m" />
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-122" data-mp="kujie4de2136">
          {bonuses.map(b => <article key={b.number} className="flex flex-col overflow-hidden rounded-3xl bg-white" data-id="element-123" data-mp="funlsq70tbxn">
              <div className="relative bg-white" data-id="element-124" data-mp="1etev87eftq7d">
                <img src={b.image} alt={`${b.title} mockup`} className="block aspect-[4/3] w-full object-cover" loading="lazy" data-id="element-125" data-mp="1eru3epjicld7" />
                <span className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-gold px-3 py-1.5 text-xs font-extrabold uppercase tracking-wide text-navy" data-id="element-126" data-mp="15ti3ty0nyd8m">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-127" data-mp="1atwfrr5dy7bx" />
                  Bonus {b.number}
                </span>
              </div>
              <div className="flex flex-1 flex-col border-t border-navy/10 p-5" data-id="element-128" data-mp="10uxcyp7ax5wu">
                <h3 className="text-xl font-extrabold leading-tight text-navy" data-id="element-129" data-mp="n30n6rt3v83m">{b.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-navy/75" data-id="element-130" data-mp="r3klvztbujrv">{b.text}</p>
                <p className="mt-auto pt-4 text-sm font-extrabold text-cta-dark" data-id="element-131" data-mp="d4kyswlgqcxt">Included free with your purchase</p>
              </div>
            </article>)}
        </div>

        <p className="mt-8 text-center text-base font-extrabold uppercase tracking-wide text-gold" data-id="element-132" data-mp="i58mb8ahgbna">
          All 5 bonuses included with your purchase.
        </p>

        <div className="px-2" data-id="element-133" data-mp="2f0abpivdrbo1">
          <SectionCTA label="Claim My 5 Bonuses" dark data-id="element-134" data-mp="2f00i7lb4mmdl" />
        </div>
      </div>
    </section>;
}